import 'bootstrap/js/dist/tab';

(function ($, Drupal, drupalSettings, once) {

  'use strict';

  const container = document.querySelector('.js-carousel');

  const carouselTestimonies = document.querySelector('.carousel-testimonies');

  // Exit on pages where the container does not exist.
  if (!container) return;

  const navLinks = [...container.querySelectorAll('.nav-link')];

  /*
   * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
   * Behaviors and event management
   * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
   */


  let index = 0;
  if (carouselTestimonies) {
    index = Math.floor(Math.random() * (navLinks.length));
  }

  Drupal.behaviors.promutuel_careerBenefits = {
    attach: function attach(context) {

      $(once('promutuelCareerBenefits', container, context)).each(function () {

        // 'Forward nav' button.
        container.querySelectorAll('.js-nav-forward').forEach(node => {
          node.addEventListener('click', event => {
            event.preventDefault();
            $(navLinks[(getActiveSlideIndex() + 1) % navLinks.length]).tab('show');
            restartAutoSlide();
          });
        });

        // 'Back nav' button.
        container.querySelectorAll('.js-nav-backward').forEach(node => {
          node.addEventListener('click', event => {
            event.preventDefault();
            $(navLinks[(getActiveSlideIndex() - 1 + navLinks.length) % navLinks.length]).tab('show');
            restartAutoSlide();
          });
        });

        navLinks.forEach(element => {
          element.addEventListener('click', _ => {
            restartAutoSlide();
          });
        });

        // Compute maximum content height and set it so the layout won't move.
        let maxHeight = 0;
        navLinks.forEach(element => {
          const id = element.getAttribute('aria-controls');
          document.getElementById(id).classList.add('show', 'active');
          maxHeight = Math.max(maxHeight, container.querySelector('.tab-content').offsetHeight);
          document.getElementById(id).classList.remove('show', 'active');
        });
        const jsTabContent = container.querySelector('.js-tab-content');
        if (jsTabContent) {
          jsTabContent.style.height = `${maxHeight}px`;
        }

        // Start animation.
        setTimeout(_ => {
          $(navLinks[index]).tab('show');
          restartAutoSlide();
        }, 100);
      });
    }
  };

  function getActiveSlideIndex() {
    return navLinks.findIndex(item => item.classList.contains('active'));
  }

  let autoSlideInterval = null;

  function restartAutoSlide() {
    clearInterval(autoSlideInterval);
    autoSlideInterval = setInterval(_ => {
      $(navLinks[(getActiveSlideIndex() + 1) % navLinks.length]).tab('show');
    }, 10000);
  }

})(jQuery, Drupal, drupalSettings, once);
